import { render, staticRenderFns } from "./UserArticlesList3.vue?vue&type=template&id=b1cc9042&"
import script from "./UserArticlesList3.vue?vue&type=script&lang=js&"
export * from "./UserArticlesList3.vue?vue&type=script&lang=js&"
import style0 from "./UserArticlesList3.vue?vue&type=style&index=0&id=b1cc9042&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports